import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  NavDropdown,
  Dropdown
} from 'reactstrap';


class HeaderDropdown extends Component {

    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.state = {
        dropdownOpen: false,
        };
    }

    toggle() {
        this.setState({
            dropdownOpen: !this.state.dropdownOpen
        });
    }

    render() {
        return (
            <Dropdown nav="true" isOpen={this.state.dropdownOpen} toggle={this.toggle}>
                <DropdownToggle nav>
                    <i className="fa fa-user"></i>
                </DropdownToggle>

                <DropdownMenu right>
                    <DropdownItem header tag="div" className="text-center"><strong>Account</strong></DropdownItem>
                    <DropdownItem header tag="div" className="white-div text-center">
                        <i className="fa fa-bell-o"></i><Link to="/account/update">Wijzigen</Link>
                    </DropdownItem>
                    <DropdownItem header tag="div" className="white-div text-center">
                        <i className="fa fa-lock"></i><Link to="/account/logout">Uitloggen</Link>
                    </DropdownItem>


                </DropdownMenu>
            </Dropdown>
        )
    }
}

export default HeaderDropdown;



// WEBPACK FOOTER //
// ./src/components/Header/HeaderDropdown.js